import { getUrl } from 'helpers';
import styled from 'styled-components';

export const Container = styled.div<CommunityCardsContainerProps>`
    align-items: center;
    background:
        linear-gradient(#2f4e31, #2f4e31) padding-box,
        linear-gradient(to right, #fbe67b, #fcfbe7, #f7d14e, #d4a041) border-box;
    border-radius: 55px;
    border: 12px solid transparent;
    box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px 36px;
    position: relative;
    width: max-content;

    &:after {
        background-image: url(${getUrl('/assets/cards/overlay.png')});
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 43px;
        bottom: -1px;
        content: '';
        left: -1px;
        opacity: ${({ $overlay }) => ($overlay ? 0.22 : 0)};
        position: absolute;
        right: -1px;
        top: -1px;
        transition: opacity 0.2s;
        z-index: ${({ $overlay }) => ($overlay ? 1 : -1)};
    }
`;

const FlopLine = styled.div`
    border-top: 1px solid white;
    height: 10px;
    position: absolute;
    top: -15px;
    width: 75px;
`;

export const FlopLineLeft = styled(FlopLine)`
    border-left: 1px solid white;
    left: 0;
`;

export const FlopLineRight = styled(FlopLine)`
    border-right: 1px solid white;
    right: 0;
`;
